import React from 'react';
import { useSelector } from 'react-redux';
import LoadingButton from 'src/components/BulkOperations/_Shared/BulkActionButton/LoadingButton';
import Toast from '../Toast';
import { Heading } from '../Form';
import SuiteAreas from './SuiteAreas';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';
import {
  CommonArea,
  CommonAreaSavePayload,
  PropertyCommonAreasShape,
} from 'src/SharedCustomHooks/UseCommonAreas/useCommonAreas';
import useCommonAreaFormState, {
  UseCommonAreaFormStateReturn,
} from './useCommonAreaFormState';
import './ConfigureCommonAreaForm.scss';

interface ConfigureCommonAreaFormProps {
  property: any;
  commonAreas: CommonArea[];
  propertyCommonAreas: PropertyCommonAreasShape;
  saving: boolean;
  onSave: (payload: CommonAreaSavePayload) => Promise<boolean>;
  onClose: () => void;
}

const ConfigureCommonAreaForm = ({
  property,
  commonAreas,
  propertyCommonAreas,
  saving,
  onSave,
  onClose,
}: ConfigureCommonAreaFormProps) => {
  const user: any = useSelector(selectAuthenticatedUser);

  const {
    selectedAreas,
    commonAreasList,
    handleAreas,
    onEnterText,
    onAddArea,
    buildSavePayload,
  }: UseCommonAreaFormStateReturn = useCommonAreaFormState({
    commonAreas,
    propertyCommonAreas,
  });

  const handleSave = async (): Promise<void> => {
    const payload: CommonAreaSavePayload = {
      PropertyId: property.id,
      UserId: user?.id,
      CommonAreas: buildSavePayload(),
    };

    const success: boolean = await onSave(payload);

    if (success) {
      onClose();
    }
  };

  return (
    <div className="configure-common-area-form">
      <Toast
        message={
          <>
            You are adding common areas to <strong>{property.name}</strong>.
          </>
        }
        actions={undefined}
        color={undefined}
      />
      <Heading>Common Areas</Heading>
      <div className="configure-common-area-form-grid">
        {commonAreasList.map((area: CommonArea, i: number) => {
          const value: CommonArea | undefined = selectedAreas.find(
            (d: CommonArea) => d.id === area.id
          );

          return (
            <div
              className="configure-common-area-form-cell"
              key={`CAF-${area.id}-${i}`}
            >
              <SuiteAreas
                label={area.name}
                type="checkbox"
                id={area.id}
                value={value && value.id ? value.id : null}
                textValue={value && value.customLabel ? value.customLabel : ''}
                disabled={!value}
                onInputChange={(e: any) => onEnterText(e.target.value, area.id)}
                onChange={() => handleAreas(area.id, value, area)}
                onAddArea={() => onAddArea(area.id)}
                checked={undefined}
              />
            </div>
          );
        })}
      </div>
      <div className="configure-common-area-form-action-row">
        <LoadingButton
          actionText="Save Common Areas"
          onClick={handleSave}
          disabled={false}
          isSubmitting={saving}
        />
      </div>
    </div>
  );
};

export default ConfigureCommonAreaForm;
